<template>
    <div class="page">
        <div class="page-content">
            <el-descriptions title="资金数据" :column="4" border>
                <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="系统总抵扣券">{{ getSystemAllMoney.userMoney }}</el-descriptions-item>
                <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="系统总贡献值">{{ getSystemAllMoney.userScore }}</el-descriptions-item>
                <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="系统总悦豆">{{ getSystemAllMoney.currency8 }}</el-descriptions-item>
                <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="系统总悦果">{{ getSystemAllMoney.currency9 }}</el-descriptions-item>
            </el-descriptions>

            <div class="data-list">
                <div class="title">加权模拟</div>
                <el-divider></el-divider>
                <div class="itme-data title-txt">
                    <span style="width: 200px">今日额度</span>
                    <span style="width: 150px"></span>
                    <span style="width: 150px"></span>
                    <span style="width: 150px"></span>
                    <span style="width: 350px">今日份额</span>
                    <span style="width: 150px">用户当前拥有</span>
                    <span style="width: 150px">加权可获得</span>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日不活跃贡献值额度：{{ sumTodayMoney.inactiveScore }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1InactiveScore" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2InactiveScore" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2InactiveScore,12)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2InactiveScore,12)">减</el-button>
                    <span style="width: 350px">今日不活跃总贡献值：{{ sumTodayShare.todayInactiveScore }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.inactiveScore" @input="inputInScore"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.inactiveScore" @input="inputInScore"></el-input>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日活跃贡献值额度：{{ sumTodayMoney.activeScore }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1ActiveScore" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2ActiveScore" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2ActiveScore,13)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2ActiveScore,13)">减</el-button>
                    <span style="width: 350px">今日活跃总贡献值：{{ sumTodayShare.todayActiveScore }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.activeScore" @input="inputScore"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.activeScore" @input="inputScore"></el-input>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日不活跃悦豆额度：{{ sumTodayMoney.inactiveDou }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1InactiveDou" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2InactiveDou" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2InactiveDou,14)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2InactiveDou,14)">减</el-button>
                    <span style="width: 350px">今日不活跃总悦豆：{{ sumTodayShare.todayInactiveDou }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.inactiveDou" @input="inputInDou"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.inactiveDou" @input="inputInDou"></el-input>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日活跃悦豆额度：{{ sumTodayMoney.activeDou }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1ActiveDou" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2ActiveDou" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2ActiveDou,15)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2ActiveDou,15)">减</el-button>
                    <span style="width: 350px">今日活跃总悦豆：{{ sumTodayShare.todayActiveDou }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.activeDou" @input="inputDou"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.activeDou" @input="inputDou"></el-input>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日不活跃悦果额度：{{ sumTodayMoney.inactiveGuo }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1InactiveGuo" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2InactiveGuo" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2InactiveGuo,16)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2InactiveGuo,16)">减</el-button>
                    <span style="width: 350px">今日不活跃总悦果：{{ sumTodayShare.todayInactiveGuo }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.inactiveGuo" @input="inputInGuo"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.inactiveGuo" @input="inputInGuo"></el-input>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日活跃悦果额度：{{ sumTodayMoney.activeGuo }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1ActiveGuo" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2ActiveGuo" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2ActiveGuo,17)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2ActiveGuo,17)">减</el-button>
                    <span style="width: 350px">今日活跃总悦果：{{ sumTodayShare.todayActiveGuo }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.activeGuo" @input="inputGuo"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.activeGuo" @input="inputGuo"></el-input>
                </div>
                <el-divider></el-divider>
            </div>
        </div>
    </div>
</template>

<script>
import { get } from '@/utils/request.js';
export default {
    data() {
        return {
            getSystemAllMoney: {
                currency8: 0,
                userMoney: 0,
                currency9: 0,
                userScore: 0,
            },
            sumTodayMoney:{
                activeDou: 0,
                activeGuo: 0,
                activeScore: 0,
                inactiveDou: 0,
                inactiveGuo: 0,
                inactiveScore: 0,
            },
            sumTodayShare:{
                todayActiveDou: 0,
                todayActiveGuo: 0,
                todayActiveScore: 0,
                todayInactiveDou: 0,
                todayInactiveGuo: 0,
                todayInactiveScore: 0,
            },
            share:{
                activeDou: 0,
                activeGuo: 0,
                activeScore: 0,
                inactiveDou: 0,
                inactiveGuo: 0,
                inactiveScore: 0,
            },
            money:{
                activeDou: 0,
                activeGuo: 0,
                activeScore: 0,
                inactiveDou: 0,
                inactiveGuo: 0,
                inactiveScore: 0,
            },
            number1:{
                number1ActiveDou: 0,
                number1ActiveGuo: 0,
                number1ActiveScore: 0,
                number1InactiveDou: 0,
                number1InactiveGuo: 0,
                number1InactiveScore: 0,
            },
            number2:{
                number2ActiveDou: 0,
                number2ActiveGuo: 0,
                number2ActiveScore: 0,
                number2InactiveDou: 0,
                number2InactiveGuo: 0,
                number2InactiveScore: 0,
            }
        };
    },
    created() {
        this.getData();
    },
    methods: {
        inputInScore(){
            this.number1.number1InactiveScore = (this.sumTodayShare.todayInactiveScore * this.money.inactiveScore / this.share.inactiveScore).toFixed(4);
            this.number2.number2InactiveScore = (this.sumTodayMoney.inactiveScore - this.number1.number1InactiveScore).toFixed(4)
        },
        inputScore(){
            this.number1.number1ActiveScore = (this.sumTodayShare.todayActiveScore * this.money.activeScore / this.share.activeScore).toFixed(4);
            this.number2.number2ActiveScore = (this.sumTodayMoney.activeScore - this.number1.number1ActiveScore).toFixed(4)
        },
        inputInDou(){
            this.number1.number1InactiveDou = (this.sumTodayShare.todayInactiveDou * this.money.inactiveDou / this.share.inactiveDou).toFixed(4);
            this.number2.number2InactiveDou = (this.sumTodayMoney.inactiveDou - this.number1.number1InactiveDou).toFixed(4)
        },
        inputDou(){
            this.number1.number1ActiveDou = (this.sumTodayShare.todayActiveDou * this.money.activeDou / this.share.activeDou).toFixed(4);
            this.number2.number2ActiveDou = (this.sumTodayMoney.activeDou - this.number1.number1ActiveDou).toFixed(4)
        },
        inputInGuo(){
            this.number1.number1InactiveGuo = (this.sumTodayShare.todayInactiveGuo * this.money.inactiveGuo / this.share.inactiveGuo).toFixed(4);
            this.number2.number2InactiveGuo = (this.sumTodayMoney.inactiveGuo - this.number1.number1InactiveGuo).toFixed(4)
        },
        inputGuo(){
            this.number1.number1ActiveGuo = (this.sumTodayShare.todayActiveGuo * this.money.activeGuo / this.share.activeGuo).toFixed(4);
            this.number2.number2ActiveGuo = (this.sumTodayMoney.activeGuo - this.number1.number1ActiveGuo).toFixed(4)
        },

        onValue(orientation,value,valueType){
            if(value <= 0){
                this.$message.error("请输入大于0的数")
                return
            }

            this.$confirm(`确认${orientation ? '添加' : '减少'}：${value}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                get('/operation/dailyglobaldata/operateGlobalTodaySubsidyValue',{
                    orientation,
                    value,
                    valueType,
                }).then((res)=>{
                    if(res.success){
                        this.$message.success(res.msg)
                        this.getData();
                    }
                })
            }).catch(() => {
				
            });
        },
        getData(){
            this.getSystemAllMoney1();
            this.sumTodayMoney1();
            this.sumTodayShare1();
        },
        getSystemAllMoney1(){
            get('/operation/dailyglobaldata/getSystemAllMoney').then((res)=>{
                if(res.success){
                    this.getSystemAllMoney.currency8 = res.systemAllMoney.currency8
                    this.getSystemAllMoney.userMoney = res.systemAllMoney.userMoney
                    this.getSystemAllMoney.currency9 = res.systemAllMoney.currency9
                    this.getSystemAllMoney.userScore = res.systemAllMoney.userScore
                }
            })
        },
        sumTodayMoney1(){
            get('/operation/dailyglobaldata/sumTodaySubsidyMoney').then((res)=>{
                if(res.success){
                    this.sumTodayMoney.inactiveScore = res.todayMoney.inactiveScore
                    this.sumTodayMoney.activeScore = res.todayMoney.activeScore
                    this.sumTodayMoney.inactiveDou = res.todayMoney.inactiveDou
                    this.sumTodayMoney.activeDou = res.todayMoney.activeDou
                    this.sumTodayMoney.inactiveGuo = res.todayMoney.inactiveGuo
                    this.sumTodayMoney.activeGuo = res.todayMoney.activeGuo
                }
            })
        },
        sumTodayShare1(){
            get('/operation/dailyglobaldata/sumTodaySubsidyShare').then((res)=>{
                if(res.success){
                    this.sumTodayShare.todayInactiveScore = res.todayShare.todayInactiveScore
                    this.sumTodayShare.todayActiveScore = res.todayShare.todayActiveScore
                    this.sumTodayShare.todayInactiveDou = res.todayShare.todayInactiveDou
                    this.sumTodayShare.todayActiveDou = res.todayShare.todayActiveDou
                    this.sumTodayShare.todayInactiveGuo = res.todayShare.todayInactiveGuo
                    this.sumTodayShare.todayActiveGuo = res.todayShare.todayActiveGuo
                }
            })
        },


    }


};
</script>

<style scoped lang="scss">
.my-label{
    width: 100px;
}
.my-content{
    width: 200px;
}

.data-list{
    width: 100%;
    margin-top: 10px;

    .title{
        font-size: 16px;
        font-weight: 700;
        color: #303133;
        margin-bottom: 10px;
    }
    .itme-data{
        width: 100%;
        font-size: 14px;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: space-around;

        .title-txt{
            text-align: center;
        }
    }
}

</style>